import { render, staticRenderFns } from "./ProductSignBase.vue?vue&type=template&id=39beaf5f&scoped=true&"
import script from "./ProductSignBase.vue?vue&type=script&lang=js&"
export * from "./ProductSignBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39beaf5f",
  null
  
)

export default component.exports